import { Box, ButtonBase, Card, Stack, Typography } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';

export default function ErrorCard({ title, handleReload }) {
	if (title) {
		return (
			<Box
				component="section"
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: '20px',
				}}
			>
				<Typography
					variant="h2"
					sx={{
						fontSize: '18px',
						fontWeight: '600',
						fontFamily: 'Inter',
						color: '#23272E',
					}}
				>
					{title}
				</Typography>

				<BasicErrorCard handleReload={handleReload} />
			</Box>
		);
	}

	return <BasicErrorCard handleReload={handleReload} />;
}

function BasicErrorCard({ handleReload }) {
	return (
		<Card
			sx={{
				padding: '16px',
				display: 'flex',
				flexDirection: 'column',
				gap: '20px',
				alignItems: 'center',
				justifyContent: 'center',
				borderRadius: '8px',
				border: '1px solid #ACACAC',
				width: '100%',
			}}
		>
			<NetOffLogo />

			<Stack spacing="8px" alignItems="center">
				<Typography
					sx={{
						fontSize: '16px',
						fontWeight: '600',
						fontFamily: 'Roboto',
						color: '#00000099',
					}}
				>
					Error de Carga
				</Typography>

				<Stack alignItems="center">
					<Typography
						sx={{
							fontSize: '14px',
							fontWeight: '400',
							fontFamily: 'Roboto',
							color: '#00000061',
						}}
					>
						Ocurrió un error obteniendo los datos de embarque del SKU.{' '}
					</Typography>
					<Typography
						sx={{
							fontSize: '14px',
							fontWeight: '400',
							fontFamily: 'Roboto',
							color: '#00000061',
						}}
					>
						Por favor intenta recargar la página o prueba más tarde.
					</Typography>
				</Stack>

				<ButtonBase
					onClick={() => handleReload()}
					sx={{
						color: '#00000099',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						gap: '0.5rem',
						width: 'fit-content',
						padding: '0.5rem 1rem',
						borderRadius: '12px',
					}}
				>
					<Typography
						sx={{
							fontSize: '16px',
							fontWeight: '600',
						}}
					>
						Recargar
					</Typography>
					<ReplayIcon />
				</ButtonBase>
			</Stack>
		</Card>
	);
}

function NetOffLogo() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="28"
			height="28"
			viewBox="0 0 28 28"
			fill="none"
		>
			<title>Reload</title>
			<path
				d="M13.5001 25.7992C13.6367 25.7992 13.7721 25.7971 13.9065 25.7928C13.4677 25.261 13.0928 24.6794 12.7897 24.06C11.9321 23.7288 11.0329 22.7912 10.2649 21.1464C9.8908 20.3262 9.59197 19.4736 9.37215 18.5992H12.0473C12.1497 18.0446 12.3012 17.5112 12.5017 16.9992H9.02975C8.80839 15.6774 8.69814 14.3394 8.70015 12.9992C8.70015 11.5864 8.81695 10.2392 9.02975 8.99923H17.9705C18.1177 9.86483 18.2201 10.7832 18.2681 11.74C18.7801 11.5928 19.3092 11.4926 19.8553 11.4392C19.8064 10.6221 19.7183 9.80787 19.5913 8.99923H23.9641C24.3657 10.0488 24.6137 11.1752 24.6809 12.3496C25.2601 12.644 25.7977 12.996 26.2937 13.4056C26.3747 10.858 25.6931 8.34423 24.3365 6.18636C22.9798 4.02849 21.0098 2.32481 18.6788 1.29358C16.3478 0.262347 13.762 -0.0494667 11.2527 0.398086C8.74339 0.845639 6.42484 2.03218 4.5941 3.80568C2.76335 5.57918 1.50379 7.85889 0.976782 10.3527C0.449774 12.8466 0.679321 15.4409 1.63601 17.8035C2.59271 20.1661 4.23298 22.1892 6.34667 23.6137C8.46037 25.0382 10.9512 25.7992 13.5001 25.7992ZM13.5001 1.79923C14.5513 1.79923 15.7513 2.74323 16.7353 4.85203C17.0825 5.59763 17.3849 6.45523 17.6297 7.39923H9.37055C9.61535 6.45523 9.91775 5.59763 10.2665 4.85203C11.2473 2.74323 12.4473 1.79923 13.5001 1.79923ZM8.81535 4.17523C8.34286 5.21012 7.97671 6.29033 7.72255 7.39923H3.79775C5.14831 5.06443 7.29397 3.29361 9.84255 2.41043C9.45695 2.93843 9.11295 3.53683 8.81535 4.17523ZM7.40735 8.99923C7.20047 10.3225 7.09776 11.6599 7.10015 12.9992C7.10015 14.3912 7.20735 15.7384 7.40895 16.9992H3.03615C2.54875 15.722 2.2993 14.3663 2.30015 12.9992C2.30015 11.5912 2.56095 10.2408 3.03615 8.99923H7.40735ZM7.72255 18.5992C8.00415 19.788 8.37375 20.8744 8.81535 21.8232C9.11295 22.4616 9.45695 23.06 9.84255 23.588C7.29397 22.7048 5.14831 20.934 3.79775 18.5992H7.72255ZM17.1577 2.41043C19.7063 3.29361 21.852 5.06443 23.2025 7.39923H19.2761C19.022 6.29033 18.6558 5.21012 18.1833 4.17523C17.8988 3.55516 17.5548 2.96413 17.1561 2.41043M27.9001 20.1992C27.9001 22.1088 27.1416 23.9401 25.7913 25.2904C24.4411 26.6407 22.6097 27.3992 20.7001 27.3992C18.7906 27.3992 16.9592 26.6407 15.609 25.2904C14.2587 23.9401 13.5001 22.1088 13.5001 20.1992C13.5001 18.2897 14.2587 16.4583 15.609 15.1081C16.9592 13.7578 18.7906 12.9992 20.7001 12.9992C22.6097 12.9992 24.4411 13.7578 25.7913 15.1081C27.1416 16.4583 27.9001 18.2897 27.9001 20.1992ZM20.7001 16.1992C20.488 16.1992 20.2845 16.2835 20.1345 16.4335C19.9844 16.5836 19.9001 16.7871 19.9001 16.9992V20.1992C19.9001 20.4114 19.9844 20.6149 20.1345 20.7649C20.2845 20.9149 20.488 20.9992 20.7001 20.9992C20.9123 20.9992 21.1158 20.9149 21.2658 20.7649C21.4159 20.6149 21.5001 20.4114 21.5001 20.1992V16.9992C21.5001 16.7871 21.4159 16.5836 21.2658 16.4335C21.1158 16.2835 20.9123 16.1992 20.7001 16.1992ZM20.7001 24.3992C20.9654 24.3992 21.2197 24.2939 21.4073 24.1063C21.5948 23.9188 21.7001 23.6644 21.7001 23.3992C21.7001 23.134 21.5948 22.8797 21.4073 22.6921C21.2197 22.5046 20.9654 22.3992 20.7001 22.3992C20.4349 22.3992 20.1806 22.5046 19.993 22.6921C19.8055 22.8797 19.7001 23.134 19.7001 23.3992C19.7001 23.6644 19.8055 23.9188 19.993 24.1063C20.1806 24.2939 20.4349 24.3992 20.7001 24.3992Z"
				fill="#146992"
			/>
		</svg>
	);
}
